import { Card } from "PFComponents/card";
import { Typography } from "PFComponents/typography";
import React, { PropsWithChildren } from "react";

import css from "./admin_item_page.module.scss";

type AdminItemPageProps = PropsWithChildren<{
  title: string;
  actions?: JSX.Element;
  filtersSection?: JSX.Element;
  className?: string;
}>;

export const AdminItemPage = ({
  title,
  actions,
  className,
  filtersSection,
  children
}: AdminItemPageProps) => (
  <div className={className}>
    <header className={css.header}>
      <Typography variant="h1">{title}</Typography>
      {actions}
    </header>
    {filtersSection}
    <Card>{children}</Card>
  </div>
);
